import { useFormikContext } from 'formik';

import RadioButton from 'components/shared/RadioButton/RadioButton';

const options = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' }
];

const ExportOrientation = () => {
  const { values, setFieldValue } = useFormikContext();

  if (!values.export_type.includes('pdf')) {
    return;
  }

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Orientation
        <span className="text-danger-400">*</span>
      </label>

      <div className="mt-2 flex gap-4">
        {options?.map((option, idx) => {
          const value = option?.value;

          return (
            <RadioButton
              key={idx}
              size="medium"
              dataQA={`radio-${value}`}
              isSelected={values?.orientation === value}
              onChange={() => setFieldValue('orientation', value)}
              label={option?.label}
              name="orientation"
              wrapperClassName="w-max"
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExportOrientation;
